// A file of common action buttons

import { Button, ButtonProps } from "@mui/material";
import { useHistory } from "react-router";
import { useIntercom } from "react-use-intercom";
import * as Routes from "routes";

interface ButtonWrapperProps extends ButtonProps {
  text?: String;
}

export const UpgradeSubscriptionButton = (props: ButtonWrapperProps) => {
  const history = useHistory();

  return (
    <Button
      size={props.size}
      color={props.color}
      variant={props.variant}
      onClick={() => {
        history.push(Routes.orgManageSubscription);
      }}
      sx={props.style ? props.style : {}}
    >
      {props.text ?? "UPGRADE"}
    </Button>
  );
};

export const ContactSupportButton = (props: ButtonWrapperProps) => {
  const { show } = useIntercom();

  return (
    <Button
      size={props.size}
      color={props.color}
      variant={props.variant}
      onClick={() => {
        show();
      }}
    >
      {props.text ?? "CONTACT SUPPORT"}
    </Button>
  );
};
